import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = () => { logout(); navigate('/login'); };

  const navLinks = [
    { to: '/dashboard', label: 'Dashboard' },
    { to: '/upload', label: 'Resume' },
    { to: '/analyze', label: 'Analyze' },
    { to: '/jobs', label: 'Jobs' },
    { to: '/history', label: 'History' },
  ];

  return (
    <nav style={{ padding: '16px 32px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backdropFilter: 'blur(10px)', background: 'rgba(10,10,15,0.9)', position: 'sticky', top: 0, zIndex: 100 }}>
      <Link to="/" style={{ textDecoration: 'none', fontFamily: 'Syne', fontWeight: 800, fontSize: 18, color: 'var(--text)', display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ background: 'linear-gradient(135deg, #7c6af7, #4ecdc4)', borderRadius: 8, width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>🎯</span>
        Resume<span style={{ color: 'var(--accent)' }}>Match</span>.ai
      </Link>

      {user && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {navLinks.map(({ to, label }) => (
            <Link key={to} to={to} style={{
              textDecoration: 'none', padding: '6px 14px', borderRadius: 8, fontSize: 13,
              color: pathname === to ? 'var(--text)' : 'var(--muted)',
              background: pathname === to ? 'var(--surface2)' : 'transparent',
              transition: 'all 0.2s',
              fontFamily: 'Syne', fontWeight: 600
            }}>{label}</Link>
          ))}
          <div style={{ width: 1, height: 20, background: 'var(--border)', margin: '0 8px' }} />
          <span style={{ fontSize: 12, color: 'var(--muted)', marginRight: 8 }}>{user.name}</span>
          <button className="btn btn-ghost" style={{ padding: '6px 14px', fontSize: 12 }} onClick={handleLogout}>Logout</button>
        </div>
      )}
    </nav>
  );
}
